import React, { Suspense, useEffect, useRef, useState } from "react";
import "./Trendy.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import { FiHeart } from "react-icons/fi";
import { FaStar, FaCartPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import { Pagination } from "@mui/material";
import { AppDispatch, RootState } from "../../../App/store"; // Update path if needed
import StoreData from "../../../Data/StoreData";
import { IStockItem, StoreProduct } from "../../../Interface/Product.interface";
import { fetchStockItems } from "../../../Action/index";
import usePagination from "../../../Pagination/Usepagination";
import { useNavigate } from "react-router-dom";
import ProductSkeleton from "../../Skeleton/Skeletonmui";



const ProductList: React.FC = () => {

  const [activeTab, setActiveTab] = useState<string>("tab1");
  const [wishList, setWishList] = useState<{ [key: string]: boolean }>({});
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch<AppDispatch>();
  const { stockItems, loading, error } = useSelector((state: RootState) => state.pos);
  const navigate = useNavigate()

  
  const [filteredData, setFilteredData] = useState<IStockItem[] | null>(null);
  const paginatedSource = filteredData ?? stockItems;
  const { currentItems, currentPage, totalPages, setCurrentPage } = usePagination<IStockItem>(paginatedSource, 16);




  


  useEffect(() => {
    dispatch(fetchStockItems());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);


  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleWishlistClick = (productID: string) => {
    setWishList((prevWishlist) => ({
      ...prevWishlist,
      [productID]: !prevWishlist[productID],
    }));
  };

  const sortByPrice = (a: StoreProduct, b: StoreProduct) =>
    a.productPrice - b.productPrice;

  const sortByReviews = (a: StoreProduct, b: StoreProduct) => {
    const reviewsA = parseInt(
      a.productReviews.replace("k+ reviews", "").replace(",", "")
    );


    const reviewsB = parseInt(
      b.productReviews.replace("k+ reviews", "").replace(",", "")
    );
    return reviewsB - reviewsA;
  };

  const cartItems = useSelector((state: RootState) => state.cart.items);

  const handleAddToCart = (product: IStockItem) => {
    const productInCart = cartItems.find(
      (item: any) => item.productID === product.itemid
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: { backgroundColor: "#ff4b4b", color: "white" },
        iconTheme: { primary: "#fff", secondary: "#ff4b4b" },
      });
    } else {
      // dispatch(addToCart(product));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: { backgroundColor: "#07bc0c", color: "white" },
        iconTheme: { primary: "#fff", secondary: "#07bc0c" },
      });
    }
  };


  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);

    // Clear the previous timeout
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // Set a new debounce timeout
    debounceRef.current = setTimeout(() => {
      if (value.trim() === '') {
        setFilteredData(null); // Clear if input is empty
      } else {
        const lowerVal = value.toLowerCase();
        const filtered = stockItems.filter((item: any) =>
          item.itemname?.toLowerCase().includes(lowerVal)
        );
        setFilteredData(filtered);
      }
    }, 300); // 300ms delay
  };


  const handleOnNavigation = (product: IStockItem) => {
    navigate(`/product?id=${product.itemid}`, { state: product });
    scrollToTop()
  };


  const renderProducts = () => {
    const displayItems = filteredData ?? currentItems;

    return displayItems.map((product, index) => (
      <div className="trendyProductContainer" key={`${product.itemid}-${index}`}>
        <div className="trendyProductImages">
          <img
            src={`data:image/jpeg;base64,${product.FilePath}`}
            alt={product?.itemname}
          />
          <h4 onClick={() => handleOnNavigation(product)}>View</h4>
        </div>

        <div className="trendyProductInfo">
          <div
            className="trendyProductNameInfo"
            style={{ position: "relative", minHeight: "32px" }}
          >
            <h5>{product.itemname}</h5>
            <div
              className="priceCartIcon"
              onClick={() => handleOnNavigation(product)}
              style={{
                position: "absolute",
                top: 37,
                right: 0,
                cursor: "pointer",
              }}
            >
              <FaCartPlus />
            </div>
          </div>

          <div className="priceContainer">
            <div className="priceDetails">
              <p className="btcRate">
                ₹{product.BTCSellingRate.toFixed(2)}
                <span className="taxLabel">Inc tax</span>
              </p>
              <p className="mrpRate">₹{product.Mrprate.toFixed(2)}</p>
            </div>
          </div>
        </div>
      </div>
    ));
  };



  return (
    <div className="trendyProducts">
      <h2 style={{ color: '#5e626b' }}>Featured</h2>
      <div className="trendyTabs">
        <div className="tabs">
          {["tab1", "tab2", "tab3", "tab4"].map((tab, index) => (
            <p
              key={index}
              onClick={() => handleTabClick(tab)}
              className={activeTab === tab ? "active" : ""}
            >
              {["All", "Latest Products", "Best Seller", "Specials"][index]}
            </p>
          ))}
        </div>
        <div className="trendyTabContent">

          <input
            type="text"
            placeholder="🔍 Search for products..."
            value={searchTerm}
            onChange={handleSearchChange}
            className="productSearchInput"
          />
          {activeTab === "tab1" && (


            <div className="trendyMainContainer">

              {loading ? <ProductSkeleton count={4} /> : renderProducts()}
            </div>
          )}

          {/* {activeTab === "tab2" && (
            <div className="trendyMainContainer">
              {renderProducts([...StoreData.slice(0, 8)].reverse())}
            </div>
          )} */}
          {/* {activeTab === "tab3" && (
            <div className="trendyMainContainer">
              {renderProducts([...StoreData.slice(0, 8)].sort(sortByReviews))}
            </div>
          )} */}
          {/* {activeTab === "tab4" && (
            <div className="trendyMainContainer">
              {renderProducts([...StoreData.slice(0, 8)].sort(sortByPrice))}
            </div>
          )} */}
        </div>
      </div>
      <div className="discoverMore">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(_, value) => setCurrentPage(value)} // 
          color="primary"
          shape="rounded"
          sx={{ mt: 2 }}
        />
      </div>
    </div>
  );
};

export default ProductList;
